import TextLink from "../components/TextLink";
import { motion } from "framer-motion"
import MobileFooter from '../components/MobileFooter';

function Image(data) {
    return (
        <figure>
        <img src={data.src} />
        <figcaption className="is-size-7">
            {data.children}
        </figcaption>
    </figure>
    )
}
function About(props) {
    return (
    <motion.section className="pt-4 pl-4 pb-4 pr-4" {...props.framer.slide}>

        <div className="content is-serif is-size-4">
            <p>
                Drifting is a series of 360 generative video artworks released as NFT on the Ethereum blockchain.
                The project has launched on Tuesday 12 April in the Playground section of generative art platform <TextLink href="https://www.artblocks.io/project/286">ArtBlocks</TextLink>.
                The collection sold out on Sunday 8 May and it's now available on the secondary market of <TextLink href="https://opensea.io/collection/drifting-by-simon-de-mai">OpenSea</TextLink>.
            </p>
            <p className="has-text-centered is-uppercase">
                Intro
            </p>
            <p className="is-sans">
                <em>«Everything is running smoothly, and you?»¹</em>
            </p>

            <p>
                In these formal studies, geometric figures are cut, broken, divided, colorized and finally «set to drift»² in an endless scrolling motion. The elements in each composition vary over time without ever reaching a final form.
            </p>

            <Image src="img/iterations_new.gif" alt="Compositions derived from the same parent set side by side">Figure 1: These compositions are derived from the same unique «parent».</Image>

            <p>
            Visual artifacts remind of analog electronics. Feedback loops undermine the accuracy of digital technology. As time passes, it is increasingly difficult to recognize the original composition: frame after frame, cycle after cycle, the image is dissolved into a landscape of liquid forms and oversaturated colors.
            </p>

            <Image src="img/screenshots_new.gif" alt="How video feedback alters and distorts the composition">Figure 2: How video feedback alters the compositions.</Image>

            <p>    
                After having pursued harmony and balance, it is liberating to surrender and witness the carefully crafted compositions blend into a chaotic interplay of lights and shapes.
            </p>
           
            <p>
                Drifting, la «dérive»⁴, is an ongoing dialogue with the machine, started as an exploration of an aesthetic system and turned into a journey of self-discovery.
            </p>

            <ol className="is-size-7 dnotes">
                <li>In <a href="https://www.youtube.com/watch?v=r13I-TuDcWI" target="_blank">this sequence</a>, super computer HAL9000 is in conversation with Dave Bowman (<em>«2001: A Space Odyssey»</em>, Stanley Kubrick, 1968).</li>
                <li>Drifting is also <a href="https://www.youtube.com/watch?v=eE74jVjxsrU" target="_blank">a technique used</a> in early video art: <em>«by altering the timing pulse of the video signal, […] an image continuously drifted horizontally»</em> (<em>«Notes toward a history of image-processed video»</em>, Lucinda Furlong, 1970).</li>
                <li>«Drift» noun in French (<a href="http://www.bopsecrets.org/SI/2.derive.htm" target="_blank">see also</a> <em>«Theory of la dérive»</em>, Guy Debord, Internationale Situationniste, 1958).</li>              
            </ol>

            <Image src="img/hal9000_1.gif" alt="A still frame from movie «2001: Space Odissey» by Stanley Kubrick"></Image>
            
            <p className="has-text-centered is-uppercase">
                Credits
            </p>

            <p>
               This website has been ideated, designed and developed by <TextLink href="https://twitter.com/simondemai">Simon De Mai</TextLink> to offer an alternative way to experience his NFT project «Drifting» launched on <TextLink href="">ArtBlocks</TextLink>. 
            </p>

            <p>
                The fonts used on this website are <TextLink href="https://github.com/brycewilner/Standard">Standard</TextLink> by Bryce Wilner and <TextLink href="https://github.com/brycewilner/Standard">Meyrin</TextLink> by Brian Suda and Tom Lakesman. The ASCII art font is <TextLink href="https://patorjk.com/software/taag/#p=author&f=Flower%20Power&t=GALLERY">Flower Power</TextLink> by LG Beard.
            </p>
            
            <p>
                This NFT series is licensed under CC BY-NC-ND 4.0+
            </p>

            <p>
               I would like to thank all the collectors, the ArtBlocks team (🙏 Sarah Ross), artists and community (🔥 #block-talk), for supporting me and believing in this project. 
            </p>
        </div>
        {props.mobile&&<MobileFooter {...props} />}
    </motion.section> 

    )
}

export default About;
